import React from 'react';
import { format } from 'date-fns';
import { ContainerComponent, wrap } from 'AppReact';
import Calendar from 'containers/calendar';
import { FilterHeaderWrapper, RelativeWrapper, DropdownOuterWrapper, FlexCenterWrapper } from 'wrappers';
import { BorderlessKeyInput, Icon } from 'atoms';
import { CalendarSvg } from 'components/icons';
import Controller from './controller';
import internalState from './internalState';
import labelSwitch from './labelSwitch';

const containerRef = React.createRef();

export const definition = {
  name: 'DatePicker',
  controller: Controller,
  initialProps: ({ showOnTop, enableFullWidth, selectedDate, label, placeholder, disabledBefore, disabledAfter, hasRemove, alignRight }) => ({ showOnTop, enableFullWidth, alignRight, selectedDate, label, placeholder, disabledBefore, disabledAfter, hasRemove, entryVal: selectedDate ? format(selectedDate, 'MM/dd/yyyy') : '' }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'HeaderWrapper',
      isButton: true,
      displayState: ({ enableFullWidth }) => ({ enableFullWidth }),
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'LeftSide',
          elements: [
            {
              componentSelect: labelSwitch,
              name: 'Label',
              displayValue: ({ label }) => label.values[0],
              renderIf: ({ label }) => !!label?.component,
              bindings: ({ label }) => {
                if (label.keys?.length > 0) {
                  const combinedValues = { ...label };
                  label.keys.forEach((key, index) => {
                    combinedValues[key] = label.values[index];
                  });
                  return combinedValues;
                }
                return label;
              }
            },
            {
              component: BorderlessKeyInput,
              name: 'Input',
              displayState: ({ }) => ({ minWidth: '100px' }),
              bindings: ({ entryVal, placeholder, hasRemove }) => ({ entryVal, value: entryVal, placeholder: placeholder ?? 'mm/dd/yyyy', hasRemove })
            }
          ]
        },
        {
          component: Icon,
          name: 'CalendarIcon',
          displayValue: ({ }) => CalendarSvg({ bold: true })
        }
      ]
    },
    {
      wrapper: DropdownOuterWrapper,
      name: 'CalendarWrapper',
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      displayState: ({ showOnTop, alignRight }) => ({ showOnTop, alignRight }),
      elements: [
        {
          component: Calendar,
          name: 'Calendar',
          bindings: ({ selectedDate, disabledAfter, disabledBefore, hasRemove }) => ({ selectedDate, disabledAfter, disabledBefore, hasRemove })
        }
      ]
    }

  ]
};

const DatePicker = ContainerComponent(definition);

export default wrap(DatePicker, RelativeWrapper);
